export default {
    methods: {
        formatDate (dateString) {
            const date = new Date(dateString)

            const months = [
                'januar', 'februar', 'marts', 'april', 'maj', 'juni',
                'juli', 'august', 'september', 'oktober', 'november', 'december'
            ]

            const day = date.getDate()
            const month = months[date.getMonth()]
            const year = date.getFullYear()

            return `${day}. ${month} ${year}`
        },
        formatDateTime (dateTimeString) {
            const date = new Date(dateTimeString)
            const dateString = this.formatDate(dateTimeString)

            const hours = ('0' + date.getHours()).slice(-2)
            const minutes = ('0' + date.getMinutes()).slice(-2)

            return `${dateString} kl. ${hours}:${minutes}`
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/shared/formatDate.js